import ExportRadioGroup from './ExportRadioGroup';

const options = [
  { label: 'Portrait', value: 'portrait' },
  { label: 'Landscape', value: 'landscape' }
];

const ExportOrientation = () => (
  <ExportRadioGroup
    label="Orientation"
    field="orientation"
    options={options}
    qaPrefix="radio"
    isRequired
  />
);

export default ExportOrientation;
